import React from "react";
import styled from "styled-components";
import { size } from "styled-theme";
import { mobileBreakPoint } from "../constants";
import { LoanDetailItem } from "./loanDetailItem";
import { formatMoney } from "@utils/helpers/stringHelper";

const LoanDetailsWrapper = styled.ul`
  margin-bottom: 20px;
  
  @media only screen and (min-width: ${size(mobileBreakPoint)}) {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
`;

export const LoanDetails = ({firstName, lastName, loanAmount, emailAddress, mobilePhone}) => {
  return (
    <LoanDetailsWrapper>
      <LoanDetailItem title="Your name">
        {firstName} {lastName}
      </LoanDetailItem>
      <LoanDetailItem title="Loan amount requested">
        {formatMoney(loanAmount)}
      </LoanDetailItem>
      <LoanDetailItem title="eMail contact">
        {emailAddress}
      </LoanDetailItem>
      <LoanDetailItem title="Mobile contact">
        {mobilePhone}
      </LoanDetailItem>
    </LoanDetailsWrapper>
  )
};